import env from '@framework/env/env';

export interface IGaConfig {
  linkerDomains?: string[],
}

const gaConfig: IGaConfig = {
  linkerDomains: env('GA__LINKER_DOMAINS')?.split(','),
};

export default gaConfig;
